/**
 * A rave's backdrop: its cover under the ground's veil, so names beat the photo.
 *
 * Here rather than in `FestivalApp` because the screen that waits for the
 * lineup draws it too (`EditionProvider`), from the cover `/tenant` names —
 * the rave's own artwork while it loads, and the largest paint arriving with
 * the tenant instead of after the bundle (step 14, 2026-10-05).
 */
import type { CSSProperties } from 'react';
import './backdrop.css';

export function backdrop(coverUrl: string | null | undefined): CSSProperties | undefined {
  if (!coverUrl) return undefined;
  return {
    backgroundImage:
      'linear-gradient(var(--ground-78) 0%, var(--ground-93) 26%, var(--ground-97) 100%),'
      + `url("${coverUrl}")`,
  };
}
